<template>
  <v-form
    ref="form"
    @keyup.native.enter="save"
    class="layout wrap justify-space-between theme-settings"
  >
    <v-flex lg6 xs12 class="pt-0">
      <div class="mr-lg-4">
        <label>Название шаблона</label>
        <v-text-field
          v-model="fields.name"
          height="48"
          solo
          :rules="[rules.required]"
        >
        </v-text-field>
        <label class="d-flex">
          Адрес, на который отправится пользователь после авторизации
          <v-flex class="layout justify-end">
            <hint-widget hintName="themeSettings" type="tooltip">
              <template slot="activatorHint">
                <icon-help></icon-help>
              </template>
            </hint-widget>
          </v-flex>
        </label>
        <v-text-field
          v-model="fields.link"
          height="48"
          solo
          :rules="[rules.url]"
        ></v-text-field>

        <label>Текст после авторизации на русском языке</label>
        <v-text-field
          v-model="fields.params.textSuccess.ru"
          height="48"
          solo
        ></v-text-field>

        <label class="d-flex">
          Текст после авторизации на английском языке
          <v-flex class="layout justify-end">
            <hint-widget hintName="themeSettingsEng" type="tooltip">
              <template slot="activatorHint">
                <icon-help></icon-help>
              </template>
            </hint-widget>
          </v-flex>
        </label>

        <v-text-field
          v-model="fields.params.textSuccess.en"
          height="48"
          solo
        ></v-text-field>
      </div>
    </v-flex>
    <v-flex lg6 xs12>
      <div class="ml-lg-4 mb-3 mb-sm-0">
        <div class="font-weight-bold">
          Хот-споты, к которым применяется тема
        </div>

        <div
          v-for="hotspot in hotspotListSelected"
          :key="hotspot.id"
          class="subtitle-1 text-no-wrap mt-3 mb-2 d-flex align-center"
        >
          <span class="valign-middle font-weight-bold flex-none">
            {{ hotspot.title }}
            <div class="text--secondary font-weight-medium text-capitalize">
              {{ hotspot.address }}
            </div>
          </span>
          <v-btn @click="delHotspot(hotspot.id)" icon class="flex-none my-0">
            <icon-close></icon-close>
          </v-btn>
        </div>

        <v-layout class="ma-0" :class="{ 'd-block': isMobile }">
          <v-select
            :items="hotspotList"
            v-model="hotspotIdSelected"
            item-value="id"
            item-text="title"
            open-on-clear
            append-icon=""
            height="48"
            dense
            solo
          >
            <template #append>
              <icon-angle class="ma-0 link"></icon-angle>
            </template>
          </v-select>

          <v-btn
            @click="addHotspot"
            class="primary my-0"
            style="height: 48px"
            outline
            :disabled="!hotspotIdSelected"
            :block="isMobile"
          >
            Добавить
          </v-btn>
        </v-layout>
      </div>
    </v-flex>
    <v-flex xs12>
      <v-btn
        @click="save"
        class="primary ml-0"
        :class="{ 'tile btn-fixed': isMobile }"
        :block="isMobile"
      >
        Сохранить
      </v-btn>
    </v-flex>
  </v-form>
</template>

<script>
import IconAngle from "../icon/IconAngle.vue";
import IconClose from "../icon/IconClose.vue";
import IconHelp from "../icon/IconHelp.vue";
import HintWidget from "../common/HintWidget.vue";

export default {
  name: "ThemeMainSettings",

  components: {
    IconClose,
    IconAngle,
    IconHelp,
    HintWidget
  },

  props: {
    // все параметры темы
    params: {
      type: Object
    }
  },

  data: () => ({
    advertising: [],
    // выбранный хотспот для добавления
    hotspotIdSelected: null,
    rules: {
      required: v => !!v.trim() || "Поле обязательно для заполнения",
      url: v =>
        /^(https?:\/\/)?([\w.-]+)\.([\w-]{2,8}\.?)(\/[\w-.]*)*\/?$/.test(v) ||
        "Введенная строка не является ссылкой"
    }
  }),

  computed: {
    // параметры формы
    fields() {
      return this.params;
    },
    // список хотспотов, прикрепленных к теме
    hotspotListSelected() {
      let items;
      if (this.params.hotspot_themes) {
        items = this.$store.getters.hotspotList.filter(item =>
          this.params.hotspot_themes
            .map(hotspot_theme => hotspot_theme.hotspot_id)
            .includes(item.id)
        );
      }
      return items;
    },
    // список доступных хотспотов
    hotspotList() {
      let items;
      if (this.params.hotspot_themes) {
        items = this.$store.getters.hotspotList.filter(
          item =>
            !this.params.hotspot_themes
              .map(hotspot_theme => hotspot_theme.hotspot_id)
              .includes(item.id)
        );
      } else {
        items = this.$store.getters.hotspotList;
      }
      return items;
    },
    // для мобильной версии
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    }
  },

  methods: {
    /**
     * сохраняет основные параметры темы
     */
    save() {
      if (this.$refs.form.validate()) {
        this.$emit("save", this.fields);
      }
    },

    /**
     * Добавляет хотспот к теме
     * id - id хотспота
     */
    addHotspot() {
      this.$emit("addHotspot", this.hotspotIdSelected);
      this.hotspotIdSelected = null;
    },

    /**
     * Удаляет хотспот к теме
     * id - id хотспота
     */
    delHotspot(id) {
      this.$emit("delHotspot", id);
    }
  }
};
</script>
